// extracted by mini-css-extract-plugin
export default {"themeBackground":"popup_themeBackground__RNLsD"};